import type { Release } from '../releases.ts';

export default {
  version: '0.97.1',
  date: '2026-10-09',
  title: 'Storage per location chart',
  summary: [
    'Fixed: Statistics show each storage location at its own value, also while others are hidden in the legend',
  ],
  features: [],
  fixes: [
    'Statistics: storage per location now shows each location at its own value (no stacking), and toggling locations in the legend no longer redraws others at the wrong height',
  ],
} satisfies Release;
